import React, { PropTypes } from "react";
import { Button } from "react-bootstrap";

const RefreshButton = (props) => {
    const { onClick, disabled, label } = props;

    return (
        <Button
            className="refresh-button"
            bsStyle={"primary"}
            bsSize={"xsmall"}
            onClick={onClick}
            disabled={disabled}
        >
            <span>{label}</span>
        </Button>
    );
};

RefreshButton.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onClick: PropTypes.func,
};

export default RefreshButton;



// WEBPACK FOOTER //
// ./src/components/common/RefreshButton.js